import SmallSetPagination from "../pagination/SmallSetPagination";
import CommissionsPaymentsCardHorizontal from "./CommissionsPaymentsCardHorizontal";


function CommissionsPaymentsListSearch({commissions}) {

  return (
    <div className="overflow-hidden bg-white">
      <div className="relative overflow-x-auto">
        <table className="table text-gray-500">
          <thead className="text-xs text-gray-700 uppercase">
					<tr>
              <th scope="col" className="p-2">
                Data
              </th>
							<th scope="col" className="p-2">
                Montos Comisiones
              </th>
							<th scope="col" className="p-2">
                Pagado
              </th>

							<th scope="col" className="p-2">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody>
            {commissions &&
              commissions.map((commission, index) => (
                <CommissionsPaymentsCardHorizontal
                  data={commission}
                  key={index}
                  index={index}
                />
              ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}
export default CommissionsPaymentsListSearch;
